<template lang="pug">
span
  v-switch(
    :label="label"  
    small
    color="success"
    :input-value="!model.onHold" 
    :disabled="disabled.onHold" 
    @change="onHoldHandler" 
    hide-details
    :false-value="model.onHold"
    :loading="loading"
  ).mr-2.hold-switcher
  
  confirmation-dialog(
    v-model="modalShowing"
    :title="modalTitle"
    :descr="modalText"
    @okBtnClicked="send"
    @failBtnClicked="reset"
    @click:outside="reset"
  )
</template>

<script>
import ErrMixin from "@/mixins/errors.mixin"
export default {
  name: 'CandidateHoldSwitcher',
  mixins: [ErrMixin],
  inject: ['svc', 'setCurrentHoldStatus'],

  props: {
    label: {
      type: String,
      default: 'Is on Hold'
    },
    model: {
      type: Object,
      required: true
    },
    disabled: Object,
  },

  data: () => ({
    loading: false,
    modalTitle: null,
    modalText: null,
    modalShowing: false
  }),

  computed: {
    Svc() {
      return this.svc()
    }
  },

  methods:{ 
    onHoldHandler(v) {
      this.model.onHold = !v
      if(this.model.onHold) this.showConfirmationPut()
      else this.showRemoveFromOnHold()
    },

    showConfirmationPut() {
      this.freezeSwitch()
      this.modalTitle = 'Put On Hold'
      this.modalText = 'Are you sure you want to put on hold this Candidate?'
      this.modalShowing = true
    },

    freezeSwitch() {
      this.loading = true
      this.disabled.onHold = true
    },

    send() {
      this.modalShowing = false
      this.putOnHold()
    },

    async putOnHold() {
      try {
        let ids = [this.model.ID]
        await this.Svc.putOnHold(this.model.ID, this.model.onHold)
        this.unFreezeSwitch()
        this.$emit('changed')
        this.setCurrentHoldStatus({onHold: this.model.onHold, ID: this.model.ID})

      } catch (error) {
        this.model.onHold = !this.model.onHold
        this.unFreezeSwitch()
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }
    },

    unFreezeSwitch() {
      this.loading = false
      this.disabled.onHold = false
    },

    showRemoveFromOnHold() {
      this.freezeSwitch()
      this.modalTitle = 'Remove from On Hold'
      this.modalText = 'Are you sure you want to remove from on hold this Candidate?'
      this.modalShowing = true
    },
 

    reset() {
      this.modalShowing = false
      this.model.onHold = !this.model.onHold
      this.unFreezeSwitch()
    }
  },

  components: {
    confirmationDialog: () => import('@/components/global/ConfirmationDialog.vue')
  }
}
</script>

<style lang="scss" scoped>
.hold-switcher::v-deep  {
  &.v-input--selection-controls {
    margin-top: 0px;
  }
  & .v-input--switch__thumb.v-input--switch__thumb.v-input--switch__thumb  {
    color:$warning-color;
  }
  & .v-input--switch__track.v-input--switch__track.v-input--switch__track {
    color: lighten($color: $warning-color, $amount: 2.5)
  }
}
</style>